import { render, staticRenderFns } from "./userTask.vue?vue&type=template&id=f43a635c&scoped=true"
import script from "./userTask.vue?vue&type=script&lang=js"
export * from "./userTask.vue?vue&type=script&lang=js"
import style0 from "./userTask.vue?vue&type=style&index=0&id=f43a635c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43a635c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f43a635c')) {
      api.createRecord('f43a635c', component.options)
    } else {
      api.reload('f43a635c', component.options)
    }
    module.hot.accept("./userTask.vue?vue&type=template&id=f43a635c&scoped=true", function () {
      api.rerender('f43a635c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user-task/userTask.vue"
export default component.exports